import type { ReactNode } from 'react';
import { Card, SectionLabel } from '@wundo/ui';

export interface NoticeProps {
  /** What the note is about. Left out for a single sentence that speaks for itself. */
  title?: string;
  children: ReactNode;
  className?: string;
}

/**
 * A standing note beside a form: the rules the send obeys, what an edit costs.
 *
 * A quiet card rather than a coloured strip — nothing here is an error or a
 * result, it is the same text every time the page is opened, and a page of
 * yellow and blue bars reads as four things having gone wrong.
 */
export function Notice({ title, children, className }: NoticeProps) {
  return (
    <Card tone='quiet' className={className}>
      {title !== undefined && (
        <SectionLabel as='h3' className='mb-1.5'>
          {title}
        </SectionLabel>
      )}
      <div className='flex flex-col gap-1 text-sm text-ink-secondary'>{children}</div>
    </Card>
  );
}
